import { render, staticRenderFns } from "./redeem.vue?vue&type=template&id=fa39f2c0&"
import script from "./redeem.vue?vue&type=script&lang=js&"
export * from "./redeem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WizardSteps: require('/vercel/path0/components/wizard/WizardSteps.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default,Wizard: require('/vercel/path0/components/wizard/Wizard.vue').default})
